import { Routes } from '@angular/router';

import { ClaimsGuard } from '../../auth/guard/claims.guard';
import {
  AppActions,
  AppFeature,
  getClaimString,
} from '../../shared/constants/app-claims';

export const SETTINGS_ROUTES: Routes = [
  {
    path: 'users',
    canActivate: [ClaimsGuard],
    data: {
      claims: [getClaimString(AppFeature.SettingsUsers, AppActions.Read)],
    },
    loadComponent: () =>
      import('./components/users/users.component').then(m => m.UsersComponent),
  },
  {
    path: 'sign-up',
    canActivate: [ClaimsGuard],
    data: {
      claims: [getClaimString(AppFeature.SettingsUsers, AppActions.Create)],
    },
    loadComponent: () =>
      import('./components/user-sign-up/sign-up.component').then(
        c => c.SignUpComponent
      ),
  },
  {
    path: 'users/:id',
    canActivate: [ClaimsGuard],
    data: {
      claims: [getClaimString(AppFeature.SettingsUsers, AppActions.Update)],
    },
    loadComponent: () =>
      import('./components/users/edit-user/edit-user.component').then(
        m => m.EditUserComponent
      ),
  },
  {
    path: 'roles',
    canActivateChild: [ClaimsGuard],
    data: {
      claims: [getClaimString(AppFeature.SettingsRoles, AppActions.Read)],
    },
    loadComponent: () =>
      import('./components/roles/roles.component').then(m => m.RolesComponent),
  },
  {
    path: 'role-edit/:id',
    canActivate: [ClaimsGuard],
    data: {
      claims: [getClaimString(AppFeature.SettingsRoles, AppActions.Update)],
    },
    loadComponent: () =>
      import(
        './components/roles/components/role-edition/role-edition.component'
      ).then(m => m.RoleEditionComponent),
  },
  {
    path: 'role-create',
    canActivate: [ClaimsGuard],
    data: {
      claims: [getClaimString(AppFeature.SettingsRoles, AppActions.Create)],
    },
    loadComponent: () =>
      import(
        './components/roles/components/create-role/create-role.component'
      ).then(m => m.CreateRoleComponent),
  },
];
